import React from 'react';
import styleClasses from '../../../try2.module.scss';
import { IOtherDressing } from '../../../../../models/try2Combo';

const OtherDressing: React.FC<IOtherDressing> = ({ otherDressingHandler, styleClass, selectCard, isNoDressing, groupMin, label, showRedBorderAnimation }) => {
  const cardSelection = () => {
    return selectCard || isNoDressing ? styleClasses.selected : {}
  }
  const name = label ?? 'Modifiers'
  return (
    <div
      className={`${styleClasses.add_on_item_wrap} cursor-pointer shadow-box d-flex flex-column justify-content-center other-dressing-item-wrap ${styleClass && styleClasses.styleClass} ${showRedBorderAnimation ? 'border-size-select' : ''}`} //  ${cardSelection()}`} // ? No need this for now (use to check if any modifier from other modal is selected)
      onClick={otherDressingHandler}
    >
      <p className="f-s14 f-w5 mb-3">
        Other
        <br />
        {name}
        {groupMin === 0 && <>
          <br />
          or
          <br />
          No {name}
        </>}
      </p>
      <button
        type="button"
        className={`${styleClasses.item_select_btn} btn item-select-btn mx-auto mw-auto`}
      >
        Select
      </button>
    </div>
  );
};

export default OtherDressing;
